module.exports = __webpack_public_path__ + "static/media/avataroverview-video.b027bc77.mp4";